import { render, staticRenderFns } from "./OrderStatusesCard.vue?vue&type=template&id=0007961e&scoped=true&"
import script from "./OrderStatusesCard.vue?vue&type=script&lang=js&"
export * from "./OrderStatusesCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusesCard.vue?vue&type=style&index=0&id=0007961e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007961e",
  null
  
)

export default component.exports